const OPTIONS_EXTENSION_TYPE = [
    {
        label: 'CSV',
        value: 'csv'
    },
    // {
    //     label: 'XLSB',
    //     value: 'xlsb'
    // },
    // {
    //     label: 'XLS',
    //     value: 'xls'
    // },
    // {
    //     label: 'XLSX, XLSM',
    //     value: 'xlsx'
    // }
] as {
    label: string
    value: string
}[]

export { OPTIONS_EXTENSION_TYPE }
